import React from "react";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Grid,
  Typography,
} from "@material-ui/core";
import { useForm, FormContext, FieldError } from "react-hook-form";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      height: "100%",
      minHeight: "100%",
      padding: theme.spacing(3),
      overflowX: "hidden",
      overflowY: "auto",
    },
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      height: "100%",
    },
    details: {
      padding: theme.spacing(2, 0.5),
      flex: "1 1",
    },
    componentActions: {
      marginTop: theme.spacing(3),
    },
    wrapper: {
      height: "80%",
      padding: "3px",
    },
    form: {
      height: "100%",
    },
    titleFont: {
      background: "	rgb(220,220,220)",
      padding: "15px",
      textAlign: "left",
      fontFamily: "sans-serif",
    },
  })
);

interface IProps{
    agencyId:string;
    agencyDescription:string;
    campusId:string;
}

const COEAgencyReportSetup = (props:IProps) => {
  const classes = useStyles({});
  const data = useForm<any>({
    mode: "onBlur",
  });


  return (
    <div className={classes.wrapper}>
            <Grid
              container
              direction="row"
              justify="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid item xs={12} sm={12} md={12}>
                <Typography style={{textAlign:'center', marginTop:50}}>Not Implemented Yet.</Typography>
              </Grid>
            </Grid>

          </div>
  );
};

export default COEAgencyReportSetup;
